export default __webpack_public_path__ + "static/Metropolis-Black-e684b52b0a6d77b7dde7a0f93e45a93f.woff2";